module.exports = __webpack_public_path__ + "static/media/9.5d2cc245.JPG";